import type { JSX } from "react";
import { redirectToGrowXLogin } from "./app/utils/loginservice/redirectToGrowXLogin";

interface Props {
  children: JSX.Element;
  isAuth: boolean;
}

const ProtectedRoute = ({ children, isAuth }: Props) => {
  if (!isAuth) {
    redirectToGrowXLogin();
  }
  return children;
};

export default ProtectedRoute;
